import { Dimensions, ServiceDetailsModel } from '~/lib/api/smartsend/types';
import { onlyUnique } from '../../../../lib/helpers/ArrayHelper';
import { ToMillimeters } from './ToMillimeters';

export type ServiceRestrictionType = 'DIMENSIONS' | 'WEIGHT' | 'COLLECTION' | 'DELIVERY';

export function GetServiceRestrictions(
  service: ServiceDetailsModel,
  comparison: Dimensions,
  senderIsoCode: string,
  senderSubdivision: string,
  recipientIsoCode: string,
  recipientSubdivision: string
): ServiceRestrictionType[] {
  const output: ServiceRestrictionType[] = [];
  if (!service) {
    return output;
  }
  if (comparison) {
    const c = [service.MaxLength, service.MaxWidth, service.MaxHeight].sort();
    const d = [comparison.Length, comparison.Width, comparison.Height].sort();
    for (let index = 0; index < c.length; index++) {
      if (c[index] && ToMillimeters(d[index]) > c[index]) {
        output.push('DIMENSIONS');
      }
    }
    if (service.MaxWeight && comparison?.Weight > service.MaxWeight) {
      output.push('WEIGHT');
    }
  }
  if (senderIsoCode) {
    if (!service.CollectionCountries.find((x) => x.Iso3Code === senderIsoCode && x.Subdivision === senderSubdivision)) {
      output.push('COLLECTION');
    }
  }
  if (recipientIsoCode) {
    if (
      !service.DeliveryCountries.find((x) => x.Iso3Code === recipientIsoCode && x.Subdivision === recipientSubdivision)
    ) {
      output.push('DELIVERY');
    }
  }
  return output.filter(onlyUnique);
}
